<div *transloco="let t" class="relative">
	@if (showCloseButton) {
		<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="dialogRef.close(false)" [attr.aria-label]="t('commonActions.close')">
			<mat-icon>close</mat-icon>
		</button>
	}
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ titleMessage }}</h2>
	<mat-dialog-content mat-dialog-content>
		<div [innerHTML]="confirmMessage" class="white-space-pre-wrap"></div>
	</mat-dialog-content>
	<mat-dialog-actions class="flex flex-row items-center justify-end" mat-dialog-actions>
		@if (showCloseButton) {}
		@if (showConfirmButton) {
			<button (click)="dialogRef.close(true)" class="confirm-button m-2" color="primary" mat-raised-button>
				<mat-icon>check</mat-icon>
				@if (!isMobile) {
					<span>
						{{ confirmButtonText }}
					</span>
				}
			</button>
		}
	</mat-dialog-actions>
</div>
